<div class="form-footer">
  <div class="form-footer__inner">
    <ng-content></ng-content>
  </div>
</div>
